// extracted by mini-css-extract-plugin
export default {"section":"Mission-module--section--1eX1K","textWrap":"Mission-module--textWrap--32A6d","title":"Mission-module--title--WKsJp","mainText":"Mission-module--mainText--3rFRe"};